<template>
  <b-row>
    <b-col cols="12">
      <b-card no-body>
        <b-row class="mb-0">
          <b-col cols="2" class="borderRight pr-0">
            <b-card-body>
              <b-card-title>{{ $t('规则图谱') }}</b-card-title>
              <vue-perfect-scrollbar class="nodeScrollbar" style="height: 300px" :options="options">
                <b-list-group flush>
                  <b-list-group-item
                    @click="search(false)"
                    :style="selectLabelText === '全部' ? `cursor: pointer;border-left: 3px solid #1890ff;` : ''"
                    style="border: 0; cursor: pointer"
                    class="px-2"
                  >
                    <b-icon-file-earmark-code-fill class="mr-50" />
                    {{ $t('全部') }}
                  </b-list-group-item>
                  <template v-for="item in topNodeNames">
                    <b-list-group-item
                      @click="search(item)"
                      :style="selectLabelText === item ? `cursor: pointer;border-left: 3px solid #1890ff;` : ''"
                      style="border: 0; cursor: pointer"
                      class="px-2"
                    >
                      <b-icon-file-earmark-code-fill class="mr-50" />
                      {{ item }}
                    </b-list-group-item>
                  </template>
                </b-list-group>
              </vue-perfect-scrollbar>
              <hr class="offsetMargin" />
              <div>
                <b-card-text class="font-weight-bolder"> {{ $t('节点标签') }}</b-card-text>
                <template v-for="item in labelList">
                  <b-badge
                    pill
                    :variant="variantType(item)"
                    class="px-1 py-50 mr-50 mb-50 cursor-pointer"
                    @click="handleQueryNodeLabel(item)"
                  >
                    {{ item }}
                  </b-badge>
                </template>
              </div>
              <hr class="offsetMargin" />
              <div>
                <b-card-text class="font-weight-bolder"> {{ $t('关系类型') }}</b-card-text>
                <template v-for="item in relationshipsList">
                  <b-badge
                    variant="light-secondary"
                    class="px-75 py-50 mr-50 mb-50 cursor-pointer"
                    @click="handleQueryEdgeType(item)"
                  >
                    {{ item }}
                  </b-badge>
                </template>
              </div>
            </b-card-body>
          </b-col>

          <b-col cols="8" class="px-0" style="height: calc(100vh - 137px)">
            <div id="viz" style="width: 100%; height: 100%"></div>
          </b-col>

          <b-col cols="2" class="borderLeft pl-0">
            <b-card-header class="font-weight-bolder"> {{ $t('节点属性') }}</b-card-header>
            <vue-perfect-scrollbar style="height: calc(100vh - 220px)">
              <div v-if="nodeInfo">
                <div class="px-2 mb-1">
                  <b-alert variant="primary" show>
                    <div class="alert-body">
                      {{ nodeInfo.node.raw.properties.name }}
                    </div>
                  </b-alert>

                  <b-card-text class="mb-50">
                    <span class="bullet bullet-primary bullet-sm mr-50"></span>
                    {{ $t('全部连接') }}
                    <b-badge variant="light-primary" class="float-right">{{ dialogInfo.outEdges + dialogInfo.inEdges }} </b-badge>
                  </b-card-text>
                  <b-card-text class="mb-50">
                    <span class="bullet bullet-success bullet-sm mr-50"></span>
                    {{ $t('入度连接') }}
                    <b-badge variant="light-success" class="float-right">{{ dialogInfo.inEdges }} </b-badge>
                  </b-card-text>
                  <b-card-text>
                    <span class="bullet bullet-warning bullet-sm mr-50"></span>
                    {{ $t('出度连接') }}
                    <b-badge variant="light-warning" class="float-right">{{ dialogInfo.outEdges }} </b-badge>
                  </b-card-text>
                </div>

                <hr class="my-0" />

                <b-table-simple striped borderless small>
                  <b-tbody>
                    <b-tr v-for="(item, index) of Object.entries(nodeInfo.node.raw.properties)" :key="index">
                      <b-td class="pl-2">{{ item[0] }} </b-td>
                      <b-td class="text-right pr-2">{{ item[1] }} </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>

              <div v-else style="position: absolute; top: 35%" class="text-center w-100">
                <div>
                  <b-icon-arrow-left-circle-fill class="mr-25"></b-icon-arrow-left-circle-fill>
                  {{ $t('选择节点查看信息') }}
                </div>
                <b-icon-plus-circle-dotted scale="4" class="my-3" />
                <div class="text-muted">Nothing is selected</div>
              </div>
            </vue-perfect-scrollbar>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { waitForGraphRenderCompletion } from '@/libs/utils/renderCompele';

export default {
  name: 'DataVisual',
  props: {
    height: {
      type: Number,
      //   default: () => 500,
    },
  },
  data() {
    return {
      neoViz: null,
      nodeInfo: null,
      selectLabelText: '全部',
      dialogInfo: {
        show: false,
        title: '',
        inEdges: 0,
        outEdges: 0,
      },
      topNodeNames: [],
      labelList: [],
      relationshipsList: [],
      isInitialLoad: true, // 添加标志位
      options: {
        suppressScrollX: true,
      },
      serverUrl: localStorage.getItem('diaServerUrl'),
    };
  },
  components: {
    VuePerfectScrollbar,
  },
  methods: {
    variantType(label) {
      switch (label) {
        case '故障原因':
          return 'light-primary';
        case '故障名称':
          return 'light-danger';
        case '故障处理方法':
          return 'light-warning';
        case '时效性':
          return 'light-success';
        case '系统':
          return 'light-info';
        case '输入变量':
          return 'light-secondary';
        case '项目名称':
          return 'light-primary';
        default:
          return 'light-primary';
      }
    },
    search(name) {
      this.nodeInfo = null;
      if (!name) {
        this.selectLabelText = '全部';
        this.neoViz.renderWithCypher(`MATCH (n)-[r]-(m) RETURN n,r,m`);
        return;
      }
      this.selectLabelText = name;
      this.neoViz.renderWithCypher(`MATCH (n)-[r]-(m) WHERE n.name CONTAINS '${name}' RETURN n,r,m`);
    },
    handleQueryNodeLabel(label) {
      this.nodeInfo = null;
      if (!label) {
        this.neoViz.renderWithCypher(`MATCH p=()-[]->() RETURN p`);
        return;
      }
      this.neoViz.renderWithCypher(`MATCH (n:\`${label}\`) return n`);
    },
    handleQueryEdgeType(type) {
      this.nodeInfo = null;
      if (!type) {
        this.neoViz.renderWithCypher(`MATCH p=()-[]->() RETURN p`);
        return;
      }
      this.neoViz.renderWithCypher(`MATCH (n)-[r:\`${type}\`]-(m) RETURN r,n,m`);
    },
    // 使用单独的 neo4j-driver 获取 schema 信息
    async fetchSchemaInfo() {
      // 创建独立的 neo4j 驱动实例
      const driver = neo4j.driver(this.serverUrl, neo4j.auth.basic('neo4j', 'rootroot'));
      try {
        const session = driver.session();
        try {
          // 获取所有标签
          const labelResult = await session.run('CALL db.labels() YIELD label RETURN label ORDER BY label');
          this.labelList = labelResult.records.map((record) => record.get('label'));
          // 获取所有关系类型
          const relResult = await session.run(
            'CALL db.relationshipTypes() YIELD relationshipType RETURN relationshipType ORDER BY relationshipType',
          );
          this.relationshipsList = relResult.records.map((record) => record.get('relationshipType'));
        } finally {
          await session.close();
        }
      } finally {
        await driver.close();
      }
    },
    // 根据获取到的标签和关系类型创建配置
    createDynamicConfig(labels, relationshipTypes) {
      // 预定义的颜色列表
      const colors = [
        '#ec807a5f',
        '#28c76f5f',
        '#00cfe85f',
        '#ea54555f',
        '#1890ff5f',
        '#84e1ea5f',
        '#ff9f435f',
        '#82868b5f',
        '#7367f05f',
        '#ffb6c15f',
        '#98d8e55f',
        '#ffd7005f',
      ];
      // 构建 labels 配置
      const labelsConfig = {
        '*': {
          [NeoVis.NEOVIS_ADVANCED_CONFIG]: {
            function: {
              label: (node) => {
                return node.properties.name?.length > 20
                  ? node.properties.name.substr(0, 20) + '...'
                  : node.properties.name || 'Node';
              },
              color: () => ({ background: '#ec807a5f' }),
            },
          },
        },
      };
      // 为每个标签创建配置
      labels.forEach((label, index) => {
        labelsConfig[label] = {
          [NeoVis.NEOVIS_ADVANCED_CONFIG]: {
            function: {
              label: (node) => {
                return node.properties.name?.length > 20
                  ? node.properties.name.substr(0, 20) + '...'
                  : node.properties.name || label;
              },
              color: () => ({
                background: colors[index % colors.length],
              }),
            },
          },
        };
      });
      // 构建 relationships 配置
      const relationshipsConfig = {};
      relationshipTypes.forEach((relType) => {
        relationshipsConfig[relType] = {
          [NeoVis.NEOVIS_ADVANCED_CONFIG]: {
            function: {
              label: (edge) => edge.type,
            },
          },
        };
      });
      // 默认关系配置
      relationshipsConfig['*'] = {
        [NeoVis.NEOVIS_ADVANCED_CONFIG]: {
          function: {
            label: (edge) => edge.type,
          },
        },
      };
      // 根据当前页面协议判断是否启用加密
      const isHttps = window.location.protocol === 'https:';

      // 构建驱动配置 - 仅当页面使用HTTPS时添加SSL配置
      const driverConfig = {
        encrypted: isHttps ? 'ENCRYPTION_ON' : 'ENCRYPTION_OFF',
      };
      return {
        containerId: 'viz',
        neo4j: {
          serverUrl: this.serverUrl,
          serverUser: 'neo4j',
          serverPassword: 'rootroot',
          driverConfig: driverConfig,
        },
        visConfig: {
          nodes: {
            shape: 'circle',
            margin: 12,
            font: {
              size: 18,
              strokeWidth: 2, // 关键：消除字体边框/阴影
            },
            widthConstraint: { maximum: 100, minimum: 100 },
            heightConstraint: { maximum: 100, minimum: 100 },
          },
          edges: {
            arrows: {
              to: { enabled: true },
            },
          },
        },
        labels: labelsConfig,
        relationships: relationshipsConfig,
        arrows: true,
        hierarchical: true,
        hierarchical_sort_method: 'directed',
        initialCypher: `MATCH (n:系统) RETURN n`,
      };
    },
    // 简化版draw方法
    async draw() {
      try {
        // 1. 获取 schema 信息
        await this.fetchSchemaInfo();
        // 2. 根据 schema 信息创建配置
        const config = this.createDynamicConfig(this.labelList, this.relationshipsList);
        // 3. 初始化 NeoVis 实例
        this.neoViz = new NeoVis.default(config);
        // 4. 注册事件
        this.registerEvents();
        // 5. 开始渲染
        this.neoViz.render();
      } catch (error) {
        console.error('动态加载配置失败:', error);
      }
    },
    registerEvents() {
      // 点击节点事件
      this.neoViz.registerOnEvent('clickNode', (event) => {
        this.nodeInfo = JSON.parse(JSON.stringify(event));
        const nodeId = event.nodeId;
        // 检查节点是否已经加载过
        const isNodeLoaded = this.loadedNodes && this.loadedNodes.includes(nodeId);
        // 如果节点未加载过，则加载节点数据
        if (!isNodeLoaded) {
          if (!this.loadedNodes) this.loadedNodes = [];
          this.loadedNodes.push(nodeId);
          const cypher = `MATCH (n)-[r]-(m) WHERE ID(n) = ${nodeId} RETURN n, r, m`;
          // 执行更新
          this.neoViz.updateWithCypher(cypher);
        }
        // 如果节点已经加载过，直接计算出入度
        else {
          this.calculateNodeDegrees(nodeId);
        }
      });

      // 完成事件 - 用于新加载节点完成后的出入度计算
      this.neoViz.registerOnEvent('completed', () => {
        // 如果是初始加载
        if (this.isInitialLoad) {
          waitForGraphRenderCompletion('viz', () => {
            console.log('✅ 图谱已完全渲染完成');
            // 获取顶级节点
            var nodes = this.neoViz.nodes;
            var edges = this.neoViz.edges;
            var topNodes = nodes.get().filter((node) => {
              var incomingEdges = edges.get().filter((edge) => edge.to === node.id);
              return incomingEdges.length === 0;
            });
            this.topNodeNames = topNodes.map((node) => node.raw.properties.name);
            this.isInitialLoad = false;
          });
        }
        // 如果是节点更新完成，计算该节点的出入度
        else if (this.nodeInfo) {
          this.calculateNodeDegrees(this.nodeInfo.nodeId);
        }
      });

      // 错误事件
      this.neoViz.registerOnEvent('error', (error) => {
        console.error('NeoVis 错误:', error);
      });
    },
    // 计算节点出入度的独立方法
    calculateNodeDegrees(nodeId) {
      this.$nextTick(() => {
        if (this.neoViz && this.neoViz.edges) {
          const allEdges = this.neoViz.edges.get();
          console.log('allEdges:', allEdges);

          const inEdges = allEdges.filter((edge) => edge.to === nodeId).length;
          const outEdges = allEdges.filter((edge) => edge.from === nodeId).length;

          // 更新对话框信息
          this.dialogInfo.inEdges = inEdges;
          this.dialogInfo.outEdges = outEdges;
        }
      });
    },
  },
  mounted() {
    this.draw();
  },
};
</script>

<style lang="scss" scoped>
.ps-container.nodeScrollbar {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.listGroupFilter .list-group-item {
  border: 0;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
